import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../../../../context/CartContext';
import { FaPlus } from 'react-icons/fa';
import styles from './ProductCard.module.css';

function PublicProductCard({ product }) {
    const navigate = useNavigate();
    const { addToCart, loading } = useCart();

    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

    const formatPrice = (value) => {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(value);
    };

    const handleViewDetails = () => {
        navigate(`/product/${product.id}`);
    };

    const handleAddToCart = (e) => {
        e.stopPropagation();
        if (product.stock_quantity === 0) return;
        addToCart(product.id, 'Único');
    };

    const stock = (product.stock_quantity ?? product.stock ?? 0);
    const isSoldOut = stock === 0;

    return (
        <div 
            className={`${styles.card} ${isSoldOut ? styles.cardDisabled : ''}`} 
            onClick={handleViewDetails}
        >
            {/* Badge OVR-SPEC */}
            {product.featured && <span className={styles.premiumBadge}>OVR-SPEC</span>}
            
            {/* Badge de Status (Topo Direito) */}
            {!isSoldOut ? (
                <span className={styles.stockBadge}>Em estoque</span>
            ) : (
                <span className={styles.soldOutBadge}>Esgotado</span>
            )}

            <div className={styles.imageSection}>
                <img 
                    src={product.image_url 
                        ? `${API_BASE_URL}${product.image_url}` 
                        : 'https://via.placeholder.com/400x500?text=SEM+IMAGEM'} 
                    alt={product.name} 
                    className={styles.image}
                />
                {!isSoldOut && (
                    <div className={styles.imageOverlay}>
                        <span className={styles.quickViewText}>DETALHES</span>
                    </div>
                )}
            </div>

            <div className={styles.details}>
                <div className={styles.meta}>
                    <span className={styles.category}>
                        {`// ${product.category ? product.category.toUpperCase() : 'EQUIPAMENTO'}`}
                    </span>
                    <h3 className={styles.title}>{product.name}</h3>
                </div>

                <div className={styles.priceRow}>
                    <div className={styles.priceContainer}>
                        <span className={styles.priceLabel}>A PARTIR DE </span>
                        <span className={styles.priceValue}>{formatPrice(product.price)}</span>
                    </div>
                    
                    <button
                        className={styles.addBtn}
                        onClick={handleAddToCart}
                        disabled={loading || isSoldOut}
                        aria-label="Adicionar ao carrinho"
                    >
                        {isSoldOut ? (
                            <span className={styles.btnSoldOutText}>N/A</span>
                        ) : loading ? (
                            <div className={styles.loaderSmall} />
                        ) : (
                            <FaPlus />
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default PublicProductCard;